export const GET_CAMPAIGN_LIST_PENDING = 'GET_CAMPAIGN_LIST_PENDING';
export const GET_CAMPAIGN_LIST_FULFILLED = 'GET_CAMPAIGN_LIST_FULFILLED';
export const GET_CAMPAIGN_LIST_REJECTED = 'GET_CAMPAIGN_LIST_REJECTED';
